import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { InputGroup } from '../../edit/components/layout/InputGroup';
import { YearPeriod } from '../types';
import { Actions, MultiInputControls } from '../../components/form/MultiInput/MultiInputControls';
import { LabelledYear } from '../../components/form/LabelledYear';
import Label from '../../components/Label';
import { getHelp } from '../../../util/intl.utils';
import { IntlShape, useIntl } from 'react-intl';

interface Props {
  label: string;
  yearPeriods: YearPeriod[];
  onChange: (yearPeriods: YearPeriod[]) => void;
}

export const FilterByYear = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'flex flex-column gap-4'}>
      <h4>
        <Label
          label={intl.formatMessage({id: `${props.label}.label`})}
          help={getHelp(intl, `${props.label}.help`)}
        />
      </h4>
      <MultiInputControls<YearPeriod>
        canEdit={false}
        min={1}
        max={1}
        addNew={(rows: YearPeriod[]): number => rows.push({start: null, end: null})}
        renderLines={(yearPeriod: YearPeriod, onPeriodChange: (yearPeriods: YearPeriod) => void, actions: Actions, idx: number): ReactElement => {
          return <InputGroup>
            <LabelledYear
              id={`yearFrom_${idx}`}
              value={yearPeriod.start}
              onChange={(start: number): void => onPeriodChange({...yearPeriod, start})}
              label={`${props.label}.from`}
            />
            <LabelledYear
              id={`yearTill_${idx}`}
              value={yearPeriod.end}
              onChange={(end: number): void => onPeriodChange({...yearPeriod, end})}
              label={`${props.label}.till`}
            />
          </InputGroup>;
        }}
        lines={props.yearPeriods}
        onChange={(periods: YearPeriod[]): void => props.onChange(
          periods.filter((period: YearPeriod): boolean =>
            (period.start !== null && period.start !== undefined)
            || (period.end !== null && period.end !== undefined),
          ),
        )}
      />
    </div>
  );
};
